// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__fAC8w","paramInput":"JobSimulator_paramInput__1Ut4a","input":"JobSimulator_input__3Gbbr"};